<script setup lang="ts">
import type { TProfileLead } from './types'
import { TableCell, TableRow } from '~/components/ui/table'
import { Badge } from '~/components/ui/badge'
import { Button } from '~/components/ui/button'
import { getProfileLeadStatusClass } from './types'

const { t } = useI18n()

const props = defineProps<{
  lead: TProfileLead
}>()

const amountFormatter = new Intl.NumberFormat('ru-KG')

const formattedAmount = computed(() => {
  if (!props.lead.requested_amount) return '—'
  const num = parseFloat(props.lead.requested_amount)
  if (isNaN(num)) return props.lead.requested_amount
  return amountFormatter.format(num) + ' ' + props.lead.currency
})

const formattedDate = computed(() => {
  if (!props.lead.created_at) return '—'
  return useDateFormat(props.lead.created_at)
})

const organizationLabel = computed(() => {
  if (props.lead.is_common_pool) return t('page.profile.leads.all_organizations')
  return props.lead.organization?.official_title ?? '—'
})
</script>

<template>
  <TableRow>
    <TableCell class="text-gray-500">{{ lead.id }}</TableCell>
    <TableCell>{{ organizationLabel }}</TableCell>
    <TableCell class="whitespace-nowrap">{{ formattedAmount }}</TableCell>
    <TableCell class="whitespace-nowrap">{{ formattedDate }}</TableCell>
    <TableCell>
      <Badge :class="getProfileLeadStatusClass(lead.status)" variant="gray">
        {{ t(`page.b2b.leads.lead_status.${lead.status}`, lead.status) }}
      </Badge>
    </TableCell>
    <TableCell>
      <Button size="sm" variant="outline-blue" as-child>
        <NuxtLink :to="`/profile/leads/${lead.id}`">{{ t('page.b2b.leads.open') }}</NuxtLink>
      </Button>
    </TableCell>
  </TableRow>
</template>
